import { Action, createReducer, on } from '@ngrx/store';
import { CaseType } from '@wdx/clmi/clmi-swagger-gen';
import { CrudState } from '@wdx/clmi/api-services/models';
import * as caseTypesActions from './case-types.actions';

export type State = CrudState<CaseType>;

export const initialState: State = {};

const reducerSetup = createReducer(
    initialState,

    on(
        caseTypesActions.getAll,
        (state): State => ({
            ...state,
            isLoadingList: true,
            hasLoadingListError: false,
        }),
    ),

    on(
        caseTypesActions.getAllSuccess,
        (state, props): State => ({
            ...state,
            isLoadingList: false,
            list: props.caseTypes,
        }),
    ),

    on(
        caseTypesActions.getAllFailure,
        (state): State => ({
            ...state,
            isLoadingList: false,
            hasLoadingListError: true,
        }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return reducerSetup(state, action);
}
